module.exports = __webpack_public_path__ + "img/generate-03.5a6e4b48.png";